import React from 'react';
import { translate } from '../utils/translations';
import PropTypes from 'prop-types';
import { COLORS_AVISOS } from '../utils/globals';
import {
    est_cel_6,
    est_cel_8,
    est_cel_10,
    est_mar_55,
    temp_tx_puja,
    temp_tn_baixa,
    vent_50,
} from '../img';

const icons = [
    est_cel_6,
    est_cel_8,
    est_cel_10,
    est_mar_55,
    temp_tx_puja,
    temp_tn_baixa,
    vent_50,
];

const colors = COLORS_AVISOS;

const AvisosNavItem = props => {
    const { perillModerat, perillAlt, perillMoltAlt } = props.markers;
    let classes = ['mc-avisos-nav-item__icon-container'];
    if (props.isEnabled) classes = [...classes, 'current-type'];
    if (props.hasAvisos) classes = [...classes, 'has-avisos'];
    const classesString = classes.join(' ');

    return (
        <div className="AvisosNavItem mc-avisos-nav-item">
            <div className="mc-avisos-nav-item__markers">
                {perillMoltAlt && (
                    <div style={{ background: colors.perillMoltAlt }} />
                )}
                {perillAlt && <div style={{ background: colors.perillAlt }} />}
                {perillModerat && (
                    <div style={{ background: colors.perillModerat }} />
                )}
                {!perillMoltAlt &&
                    !perillAlt &&
                    !perillModerat && (
                        <div style={{ background: colors.sensePerill }} />
                    )}
            </div>
            <div
                onClick={
                    props.hasAvisos
                        ? () => props.avisosNavigation(props.type)
                        : null
                }
                className={classesString}
            >
                <img
                    src={icons[props.type]}
                    alt={translate(props.language, `avisos_type_${props.type}`)}
                    title={translate(
                        props.language,
                        `avisos_type_${props.type}`
                    )}
                />
            </div>
        </div>
    );
};

AvisosNavItem.propTypes = {
    avisosNavigation: PropTypes.func,
    isEnabled: PropTypes.bool,
    hasAvisos: PropTypes.bool,
    language: PropTypes.string,
    markers: PropTypes.shape({
        perillAlt: PropTypes.bool,
        perillModerat: PropTypes.bool,
        perillMoltAlt: PropTypes.bool,
    }),
    type: PropTypes.number,
};

export default AvisosNavItem;



// WEBPACK FOOTER //
// ./src/partials/AvisosNavItem.js